import { handleApiError } from 'utils/api_error_handler';
import { translateErrorCode } from 'utils/translate_error_code';

export const errorInterpreter = async ({ message, response }) => {
  const responseJSON = await response?.json();
  const messageOrDefault =
    message !== '' ? message : 'Ops! Tivemos um problema';

  if (responseJSON.message) {
    toastr.error(translateErrorCode(responseJSON.message));
    return;
  }

  if (responseJSON.errors.text) {
    toastr.error(translateErrorCode(responseJSON.errors.text[0]));
    return;
  }

  if (responseJSON.errors['stored_filter.subjects_ids']) {
    toastr.error(
      translateErrorCode(responseJSON.errors['stored_filter.subjects_ids'][0])
    );
    return;
  }

  if (responseJSON.errors.type) {
    toastr.error(translateErrorCode(responseJSON.errors.type[0]));
    return;
  }

  if (responseJSON.errors.question) {
    toastr.error(translateErrorCode(responseJSON.errors.question[0]));
    return;
  }

  if (responseJSON.errors.user) {
    toastr.error(translateErrorCode(responseJSON.errors.user[0]));
    return;
  }

  handleApiError(messageOrDefault, response);
};
